import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    forwardRef,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Debug from 'debug';
import { AumFormField } from './../aumFormField/aum-form-field';

const debug = Debug('aumico:aumico-lib-core-fe:AumPasswordInput');

/**
 * to overwrite the with you have to change the css of .mat-form-field-infix
 */
@Component({
    selector: 'aum-password-input',
    styleUrls: [
        './../aumFormField/aum-form-field.scss',
        './../aumFormField/aum-form-field-outline.scss',
        './../aumFormField/aum-input.scss',
        './aum-password-input.scss',
    ],
    templateUrl: './aum-password-input.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AumPasswordInput),
            multi: true,
        },
    ],
    host: {
        class: 'aum-password-input aum-form-field',
        '[class.placeholderIsVisible]': 'aumFormControl.value.length <= 0',
    },
    inputs: ['size'],
})
export class AumPasswordInput extends AumFormField implements AfterViewInit {
    constructor(
        el: ElementRef,
        changeDetectorRef: ChangeDetectorRef,
        renderer: Renderer2,
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
    ) {
        super(el, changeDetectorRef, renderer, matIconRegistry, domSanitizer);

        this.addSvgIcon('aumico-pattern-icon-view-off');
        this.addSvgIcon('aumico-pattern-icon-view-on');
    }

    @ViewChild('input', { static: true }) el: ElementRef;
    hide = true;

    ngAfterViewInit() {
        const randomString = Math.random().toString(36).slice(-6);
        this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
        this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', randomString);
    }
}
